import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Input from '../../../../Atoms/Input';
import TextArea from '../../../../Atoms/TextArea';
import ButtonMain from '../../../../Atoms/ButtonMain';
import ButtonSecondary from '../../../../Atoms/ButtonSecondary';
import './styles.css';

export default function NewIdeaModal({ 
    show, 
    onHide, 
    onConfirm 
}) {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');

    const handleConfirm = () => {
        if (title.trim() && description.trim() && onConfirm) {
            onConfirm({
                title: title.trim(),
                description: description.trim()
            });
            setTitle('');
            setDescription('');
            onHide();
        }
    };

    const handleCancel = () => {
        setTitle('');
        setDescription('');
        onHide();
    };

    const isDisabled = !title.trim() || !description.trim();

    return (
        <Modal 
            show={show} 
            onHide={handleCancel}
            centered
            backdrop="static"
            className="new-idea-modal"
        >
            <Modal.Header closeButton className="new-idea-modal-header">
                <Modal.Title>Nova Ideia</Modal.Title>
            </Modal.Header>
            
            <Modal.Body className="new-idea-modal-body">
                <Input
                    label="Título"
                    placeholder="Digite o título da ideia"
                    mandatory={true}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
                
                <TextArea
                    label="Descrição"
                    placeholder="Descreva a ideia em detalhes"
                    mandatory={true}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    maxLength={500}
                    textAreaStyle={{ minHeight: '120px' }}
                />
                
                <div className="character-count">
                    {description.length}/500 caracteres
                </div>
            </Modal.Body>
            
            <Modal.Footer className="new-idea-modal-footer">
                <ButtonSecondary onClick={handleCancel}>
                    Cancelar
                </ButtonSecondary>
                <ButtonMain 
                    onClick={() => handleConfirm()}
                    disabled={isDisabled}
                >
                    Criar
                </ButtonMain>
            </Modal.Footer>
        </Modal>
    );
}


